module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__foot"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "copyright",
      "scale": "1"
    }
  }), _vm._v(" 2017 - BARNA-TASA, S.A.")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "1"
    }
  }), _vm._v(" Carrer de Còrsega, 168, 1º 1ª, 08036 - Barcelona")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "phone",
      "scale": "1"
    }
  }), _vm._v(" (+34) 93 410 05 32")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "1"
    }
  }), _vm._v(" info@barnatasa.com")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52c785e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = 2148
// module chunks = 0